import * as Yup from "yup";
import { TypeOfClassroomBasedOnEnrollments } from "services/domain/administration/Classroom";

const TRANSLATION_BASE_PATH = "_ADMIN._ORGANIZATIONS";

export const formValidator = (translate: (key: string) => string) =>
	Yup.object({
		name: Yup.string()
			.nullable()
			.trim()
			.max(255, translate(`${TRANSLATION_BASE_PATH}._MAX_LENGTH_255`))
			.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`)),
		level: Yup.string()
			.nullable()
			.trim()
			.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`)),
		gradeId: Yup.string()
			.nullable()
			.trim()
			.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`)),
		subjectId: Yup.string()
			.nullable()
			.trim()
			.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`)),
		numberOfStudents: Yup.number()
			.nullable()
			.notRequired()
			.typeError(translate(`${TRANSLATION_BASE_PATH}._ONLY_NUMBERS`))
			.when("virtualClassroomType", {
				is: (virtualClassroomType: string) => virtualClassroomType && virtualClassroomType === TypeOfClassroomBasedOnEnrollments.Group,
				then: Yup.number()
					.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`))
					.typeError(translate(`${TRANSLATION_BASE_PATH}._ONLY_NUMBERS`))
					.test("is-valid-number-of-students", translate(`${TRANSLATION_BASE_PATH}._NUMBER_OF_STUDENTS_FOR_GROUP_CLASSROOM`), function (value) {
						return (
							value >= 2 && value <= 100
						);
					})
			})	
	});